import { ReactComponent as AlertsSvg } from './alerts-icon.svg'
export default AlertsSvg
